import { render, staticRenderFns } from "./SessionsList.vue?vue&type=template&id=884f8444&scoped=true&"
import script from "./SessionsList.vue?vue&type=script&lang=js&"
export * from "./SessionsList.vue?vue&type=script&lang=js&"
import style0 from "./SessionsList.vue?vue&type=style&index=0&id=884f8444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884f8444",
  null
  
)

export default component.exports